import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import { IFormStudentInformation } from "../Models/Forms/IFormStudentInformation";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';

@Injectable()
export class FormStudentInformationService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string, ) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormStudentInformation(id: number) {
    return this._http.get(this._baseUrl + "api/FormStudentInformation/" + id)
      .map((response: IFormStudentInformation) => response as IFormStudentInformation)
      .catch(this.errorHandler)
  }

  insertUpdateFormStudentInformation(formStudentInformationDetails:IFormStudentInformation) {
    return this._http.post(this._baseUrl + 'api/FormStudentInformation', formStudentInformationDetails)
      .map((response: IFormStudentInformation) => response as IFormStudentInformation)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormStudentInformation/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  deleteStudentInformation(id) {
    return this._http.delete(this._baseUrl + "api/FormStudentInformation" + id)
      .map((response: IFormStudentInformation) => response as IFormStudentInformation)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}

